import { render, staticRenderFns } from "./InputComponent.vue?vue&type=template&id=4b4a260e&"
import script from "./InputComponent.vue?vue&type=script&lang=ts&"
export * from "./InputComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b4a260e')) {
      api.createRecord('4b4a260e', component.options)
    } else {
      api.reload('4b4a260e', component.options)
    }
    module.hot.accept("./InputComponent.vue?vue&type=template&id=4b4a260e&", function () {
      api.rerender('4b4a260e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/InputComponent.vue"
export default component.exports